import { render, staticRenderFns } from "./MatrixMultiplierSectionWeightTableColumn.vue?vue&type=template&id=1696622c"
import script from "./MatrixMultiplierSectionWeightTableColumn.vue?vue&type=script&lang=js"
export * from "./MatrixMultiplierSectionWeightTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports